$(document).on("turbolinks:load", function () {
  let $button = $(".js-shop-follow-button")

  $button.on("click", function (e) {
    let $this = $(this)

    let user_id = $this.data("user-id")
    var followId = $this.data("follow-id")
    let shop_id = $this.data("shop-id")

    // This is needed to reinitialize the js with TurboLinks
    if (followId) {
      e.preventDefault()
    }

    if (followId) {
      $.ajax({
        type: "PATCH",
        data: {
          shop_follow: {
            active: $this.text().trim() == "Follow" ? true : false,
          },
        },
        url: `/account/privacy-center/shop_follows/${followId}`,
        dataType: "json",
        success: function () {
          $this.text($this.text().trim() == "Follow" ? "Unfollow" : "Follow")
        },
      })
    } else {
      $.ajax({
        type: "POST",
        data: { shop_follow: { user_id, shop_id } },
        url: `/account/privacy-center/shop_follows`,
        dataType: "json",
        success: function (data) {
          $this.attr("data-follow-id", data.id)
          followId = data.id
          $this.text($this.text().trim() == "Follow" ? "Unfollow" : "Follow")
        },
      })
    }
  })
})
